import React, { useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { Select, Col } from "antd";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import ErrorMessage from "../../Forms/ErrorMessage";
import { useTranslation } from "react-i18next";

const OfficeDropDown = ({ formik }) => {
  const { t } = useTranslation();
  const axiosInstance = useAxiosInstance();

  // Fetch Office List
  const fetchOfficeList = async () => {
    return axiosInstance.get(`/api/clients/office/info`);
  };

  const officeList = useQuery("client-office-List", fetchOfficeList, {
    retry: 1,
  });

  const offices = officeList?.data?.data?.data?.results || [];

  // Find oldest office (created first)
  const oldestOffice = useMemo(() => {
    if (!offices.length) return null;
    return [...offices].sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    )[0];
  }, [offices]);

  // Auto-assign office if chief_of_staff
  useEffect(() => {
    if (
      formik.values.role === "chief_of_staff" &&
      oldestOffice &&
      !formik.values.officeId
    ) {
      formik.setFieldValue("officeId", oldestOffice._id);
    }
  }, [formik.values.role, oldestOffice, formik]);

  // Decide which list to render
  const officesToRender =
    formik.values.role === "chief_of_staff" && oldestOffice
      ? [oldestOffice]
      : offices;

  return (
    <Col span={9} className="mr-6">
      <label>{t("Office")}</label>
      <Select
        placeholder="Select office"
        name="officeId"
        value={formik.values.officeId}
        onChange={(value) => formik.setFieldValue("officeId", value)}
        // disabled={formik.values.role === "chief_of_staff"} // optional: disable selection for chief_of_staff
      >
        {officesToRender.map((office) => (
          <Select.Option key={office._id} value={office._id}>
            {office.officeName}
          </Select.Option>
        ))}
      </Select>
      <ErrorMessage
        hasError={Boolean(formik.errors.officeId && formik.touched.officeId)}
        message={formik.errors.officeId}
      />
    </Col>
  );
};

export default OfficeDropDown;
